export default class {
  constructor() {
    this.$category = $(".js-filter select");
    this.$archive = $(".js-filter-archive");
  }

  init() {
    $(() => {
      const self = this;
      this.$archive.submit((e) => {
        e.preventDefault();
        const data = this.$archive.serializeArray();
        if (data && data.length) {
          const pattern = /page\/[0-9]\//;
          const currentUrl = window.location.href;
          const url = new URL(currentUrl.replace(pattern, ""));
          url.searchParams.set("cat", data[0].value);
          url.searchParams.set("y", data[1].value);
          url.searchParams.set("mon", data[2].value);
          // eslint disable next line
          window.location.href = url;
        }
      });
      this.$archive.find(".js-year").change(() => {
        self.updateMonths();
      });

      this.$category.change((e) => {
        e.preventDefault();
        const url = this.$category.find("option:selected").data("link");
        if (url) {
          window.location.href = url;
        }
      });
    });
  }

  updateMonths() {
    const months = this.$archive
      .find(".js-year option:selected")
      .data("months");
    const monthSelect = this.$archive.find(".js-month");
    if (months && monthSelect.length) {
      monthSelect.val(null).empty();
      months.forEach((item) => {
        monthSelect.append(
          $("<option></option>").attr("value", item.month).text(item.name),
        );
      });
      monthSelect.trigger("focus");
    }
  }
}
